// import React, { useState } from 'react';
// import { ToastContainer } from 'react-toastify';
// import 'react-toastify/dist/ReactToastify.css';
// import { useDispatch } from 'react-redux'
// import { loginUser } from '../../Features/userSlice';
// import "./Login.css";

// const Login = () => {
//     const [username, setUserName] = useState('')
//     const [password, setPassword] = useState('')
//     const dispatch = useDispatch()

//     const CheckLogin = async (e) => {

//         e.preventDefault();
//         if (validate()) {
//             const data = {
//                 "userName": username,
//                 "password": password,
//             }
//             dispatch(loginUser(data))
//         }
//     }

//     const validate = () => {
//         let result = true;
//         if (username === '' || username === null) {
//             result = false;
//         }
//         if (password === '' || password === null) {
//             result = false;
//         }
//         return result;
//     }

//     return (
//         <>
//             <ToastContainer />
//             <div className='LoginSection'>
//                 <div className="form-box">
//                     <div className="form-value">
//                         <form>
//                             <h2 className='heading'>Login</h2>
//                             <div className="input-box">
//                                 <ion-icon name="mail-outline"></ion-icon>
//                                 <input type="text" value={username} onChange={(e) => setUserName(e.target.value)} placeholder="User Name" />
//                             </div>
//                             <div className="input-box">
//                                 <ion-icon name="lock-closed-outline"></ion-icon>
//                                 <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Password" />
//                             </div>
//                             <button className="btntheam" type="submit" onClick={CheckLogin}>Login</button>
//                         </form>
//                     </div>

//                 </div>
//             </div>
//         </>
//     )
// }

// export default Login

import React, { useState } from 'react';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useDispatch } from 'react-redux';
import { loginUser } from '../../Features/userSlice';
import './Login.css';
import CompanyLogo from '../../assets/Asian Lab Logo.png'; // Replace with your logo path

const Login = () => {
    const [username, setUserName] = useState('');
    const [password, setPassword] = useState('');
    const [showPassword, setShowPassword] = useState(false); // State to toggle password visibility
    const dispatch = useDispatch();

    const CheckLogin = async (e) => {
        e.preventDefault();
        if (validate()) {
            const data = {
                userName: username,
                password: password,
            };
            dispatch(loginUser(data));
        }
    };

    const validate = () => {
        let result = true;
        if (username === '' || username === null) {
            result = false;
        }
        if (password === '' || password === null) {
            result = false;
        }
        return result;
    };

    return (
        <>
            <ToastContainer />
            <div className="LoginSection">
                <div className="form-box">
                    <div className="form-value">
                        <div className="logo-container">
                            <img src={CompanyLogo} alt="Company Logo" className="company-logo" />
                        </div>
                        <p className="subheading">Login to access your account</p>
                        <form onSubmit={CheckLogin}>
                            <div className="input-box">
                                <ion-icon name="person-outline"></ion-icon>
                                <input
                                    type="text"
                                    value={username}
                                    onChange={(e) => setUserName(e.target.value)}
                                    placeholder="Username"
                                    required
                                />
                            </div>
                            <div className="input-box">
                                <ion-icon name="lock-closed-outline"></ion-icon>
                                <input
                                    type={showPassword ? "text" : "password"} // Toggle input type
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                    placeholder="Password"
                                    required
                                />
                                <ion-icon
                                    name={showPassword ? "eye-off-outline" : "eye-outline"} // Toggle eye icon
                                    onClick={() => setShowPassword(!showPassword)} // Toggle visibility
                                    style={{ cursor: 'pointer', position: 'absolute', right: '35px', top: '50%', transform: 'translateY(-50%)' }}
                                />
                            </div>
                            <button className="btntheam" type="submit">
                                Login
                            </button>
                        </form>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Login;